// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.championships-page {
  display: grid;
  gap: 20px;
}

.championships-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 18px;
}

.championship-card {
  position: relative;
  overflow: hidden;
  display: grid;
  gap: 14px;
  padding: 18px;
  border-radius: 20px;
  border: 1px solid rgba(125, 151, 178, 0.18);
  background: linear-gradient(168deg, rgba(10, 22, 41, 0.98), rgba(5, 12, 24, 0.96));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03), 0 16px 32px rgba(2, 8, 23, 0.2);
  cursor: pointer;
  transition: box-shadow 180ms ease, border-color 180ms ease;
}

.championship-card:hover {
  border-color: color-mix(in srgb, var(--accent-start) 42%, rgba(125, 151, 178, 0.28));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 0 0 1px color-mix(in srgb, var(--accent-start) 35%, transparent), 0 20px 40px rgba(2, 8, 23, 0.28);
}

.championship-card-accent {
  position: absolute;
  inset: 0 0 auto 0;
  height: 3px;
  background: linear-gradient(90deg, var(--accent-start), var(--accent-end));
}

.championship-card-top {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;
  gap: 0 12px;
  padding-top: 2px;
}

.championship-card-top h3 {
  grid-column: 1;
  grid-row: 1;
  margin: 0;
  color: #f8fafc;
  font-size: 1.05rem;
  align-self: center;
}

.championship-card-top .status-pill {
  grid-column: 2;
  grid-row: 1;
  align-self: start;
}

.championship-subtitle {
  grid-column: 1 / -1;
  grid-row: 2;
  margin: 6px 0 0;
  color: #94a3b8;
  font-size: 0.9rem;
  line-height: 1.45;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  white-space: nowrap;
  background: rgba(148, 163, 184, 0.15);
  color: #e2e8f0;
}

.status-pill.live {
  color: #86efac;
  background: rgba(16, 185, 129, 0.16);
}

.status-pill.upcoming {
  color: #7dd3fc;
  background: rgba(14, 165, 233, 0.16);
}

.status-pill.ended {
  color: #fda4af;
  background: rgba(244, 63, 94, 0.16);
}

.championship-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.info-pill {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex: 1 1 140px;
  padding: 8px 10px;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid rgba(96, 165, 250, 0.18);
  color: #f8fafc;
  min-height: 41px;
}

.pill-label {
  color: #94a3b8;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.pill-value {
  color: #f8fafc;
  font-size: 0.8rem;
  font-weight: 700;
}

.info-pill.is-full {
  border-color: rgba(248, 113, 113, 0.4);
}

.players-bulb {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 999px;
  background: rgba(34, 197, 94, 0.16);
  color: #bbf7d0;
  font-weight: 700;
  white-space: nowrap;
  flex-wrap: nowrap;
  min-width: max-content;
  font-size: 0.78rem;
}

.players-bulb-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4ade80;
  box-shadow: 0 0 10px rgba(74, 222, 128, 0.45);
}

.info-pill.is-full .players-bulb {
  background: rgba(248, 113, 113, 0.16);
  color: #fecaca;
}

.info-pill.is-full .players-bulb-dot {
  background: #f87171;
  box-shadow: 0 0 10px rgba(248, 113, 113, 0.4);
}

.championship-details {
  display: grid;
  gap: 8px;
  padding: 10px 0;
  border-top: 1px solid rgba(148, 163, 184, 0.14);
  border-bottom: 1px solid rgba(148, 163, 184, 0.14);
}

.detail-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 0.9rem;
}

.detail-label {
  color: #94a3b8;
}

.detail-value {
  color: #f8fafc;
  text-align: right;
  font-weight: 600;
}

.championship-progress {
  display: grid;
  gap: 8px;
}

.progress-head {
  display: flex;
  justify-content: space-between;
  color: #e2e8f0;
  font-size: 0.9rem;
}

.progress-bar {
  width: 100%;
  height: 10px;
  border-radius: 999px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.06);
}

.progress-fill {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, var(--progress-start), var(--progress-end));
  transition: width 200ms ease;
}

.championship-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 2px;
}

.championship-button {
  border: none;
  border-radius: 999px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  font-weight: 600;
}

.championship-button.primary {
  background: linear-gradient(90deg, var(--accent-start), var(--accent-end));
  color: white;
}

.championship-button.secondary {
  background: rgba(148, 163, 184, 0.12);
  color: #e2e8f0;
}

.championship-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.championship-registration-table {
  display: grid;
  gap: 10px;
  border: 1px solid var(--border);
  border-radius: 16px;
  background: var(--surface-strong);
  padding: 12px;
}

.championship-registration-table .table-row {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1.5fr;
  gap: 12px;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid rgba(148, 163, 184, 0.12);
}

.championship-registration-table .table-row:last-child {
  border-bottom: none;
}

.championship-registration-table .table-header {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--muted);
}

.championship-registration-table .table-cell {
  color: var(--text);
  font-size: 0.95rem;
}

.championship-registration-table select {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 10px 12px;
  background: var(--surface);
  color: var(--text);
  font: inherit;
}

.championship-registration-table select:disabled {
  opacity: 0.75;
  cursor: not-allowed;
  background: rgba(148, 163, 184, 0.08);
}

.championship-registration-table option {
  background: var(--surface);
  color: var(--text);
}
`, "",{"version":3,"sources":["webpack://./src/pages/ChampionshipsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,kFAAkF;EAClF,oFAAoF;EACpF,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,oFAAoF;EACpF,yJAAyJ;AAC3J;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;EACjC,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,8EAA8E;EAC9E,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0EAA0E;EAC1E,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB","sourcesContent":[".championships-page {\r\n  display: grid;\r\n  gap: 20px;\r\n}\r\n\r\n.championships-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 18px;\r\n}\r\n\r\n.championship-card {\r\n  position: relative;\r\n  overflow: hidden;\r\n  display: grid;\r\n  gap: 14px;\r\n  padding: 18px;\r\n  border-radius: 20px;\r\n  border: 1px solid rgba(125, 151, 178, 0.18);\r\n  background: linear-gradient(168deg, rgba(10, 22, 41, 0.98), rgba(5, 12, 24, 0.96));\r\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03), 0 16px 32px rgba(2, 8, 23, 0.2);\r\n  cursor: pointer;\r\n  transition: box-shadow 180ms ease, border-color 180ms ease;\r\n}\r\n\r\n.championship-card:hover {\r\n  border-color: color-mix(in srgb, var(--accent-start) 42%, rgba(125, 151, 178, 0.28));\r\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 0 0 1px color-mix(in srgb, var(--accent-start) 35%, transparent), 0 20px 40px rgba(2, 8, 23, 0.28);\r\n}\r\n\r\n.championship-card-accent {\r\n  position: absolute;\r\n  inset: 0 0 auto 0;\r\n  height: 3px;\r\n  background: linear-gradient(90deg, var(--accent-start), var(--accent-end));\r\n}\r\n\r\n.championship-card-top {\r\n  display: grid;\r\n  grid-template-columns: 1fr auto;\r\n  grid-template-rows: auto auto;\r\n  gap: 0 12px;\r\n  padding-top: 2px;\r\n}\r\n\r\n.championship-card-top h3 {\r\n  grid-column: 1;\r\n  grid-row: 1;\r\n  margin: 0;\r\n  color: #f8fafc;\r\n  font-size: 1.05rem;\r\n  align-self: center;\r\n}\r\n\r\n.championship-card-top .status-pill {\r\n  grid-column: 2;\r\n  grid-row: 1;\r\n  align-self: start;\r\n}\r\n\r\n.championship-subtitle {\r\n  grid-column: 1 / -1;\r\n  grid-row: 2;\r\n  margin: 6px 0 0;\r\n  color: #94a3b8;\r\n  font-size: 0.9rem;\r\n  line-height: 1.45;\r\n}\r\n\r\n.status-pill {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 999px;\r\n  padding: 6px 10px;\r\n  font-size: 0.75rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.06em;\r\n  text-transform: uppercase;\r\n  white-space: nowrap;\r\n  background: rgba(148, 163, 184, 0.15);\r\n  color: #e2e8f0;\r\n}\r\n\r\n.status-pill.live {\r\n  color: #86efac;\r\n  background: rgba(16, 185, 129, 0.16);\r\n}\r\n\r\n.status-pill.upcoming {\r\n  color: #7dd3fc;\r\n  background: rgba(14, 165, 233, 0.16);\r\n}\r\n\r\n.status-pill.ended {\r\n  color: #fda4af;\r\n  background: rgba(244, 63, 94, 0.16);\r\n}\r\n\r\n.championship-pills {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n.info-pill {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  flex: 1 1 140px;\r\n  padding: 8px 10px;\r\n  border-radius: 12px;\r\n  background: rgba(15, 23, 42, 0.8);\r\n  border: 1px solid rgba(96, 165, 250, 0.18);\r\n  color: #f8fafc;\r\n  min-height: 41px;\r\n}\r\n\r\n.pill-label {\r\n  color: #94a3b8;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.08em;\r\n}\r\n\r\n.pill-value {\r\n  color: #f8fafc;\r\n  font-size: 0.8rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.info-pill.is-full {\r\n  border-color: rgba(248, 113, 113, 0.4);\r\n}\r\n\r\n.players-bulb {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 8px;\r\n  border-radius: 999px;\r\n  background: rgba(34, 197, 94, 0.16);\r\n  color: #bbf7d0;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n  flex-wrap: nowrap;\r\n  min-width: max-content;\r\n  font-size: 0.78rem;\r\n}\r\n\r\n.players-bulb-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #4ade80;\r\n  box-shadow: 0 0 10px rgba(74, 222, 128, 0.45);\r\n}\r\n\r\n.info-pill.is-full .players-bulb {\r\n  background: rgba(248, 113, 113, 0.16);\r\n  color: #fecaca;\r\n}\r\n\r\n.info-pill.is-full .players-bulb-dot {\r\n  background: #f87171;\r\n  box-shadow: 0 0 10px rgba(248, 113, 113, 0.4);\r\n}\r\n\r\n.championship-details {\r\n  display: grid;\r\n  gap: 8px;\r\n  padding: 10px 0;\r\n  border-top: 1px solid rgba(148, 163, 184, 0.14);\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.14);\r\n}\r\n\r\n.detail-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.detail-label {\r\n  color: #94a3b8;\r\n}\r\n\r\n.detail-value {\r\n  color: #f8fafc;\r\n  text-align: right;\r\n  font-weight: 600;\r\n}\r\n\r\n.championship-progress {\r\n  display: grid;\r\n  gap: 8px;\r\n}\r\n\r\n.progress-head {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  color: #e2e8f0;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.progress-bar {\r\n  width: 100%;\r\n  height: 10px;\r\n  border-radius: 999px;\r\n  overflow: hidden;\r\n  background: rgba(255, 255, 255, 0.06);\r\n}\r\n\r\n.progress-fill {\r\n  height: 100%;\r\n  border-radius: inherit;\r\n  background: linear-gradient(90deg, var(--progress-start), var(--progress-end));\r\n  transition: width 200ms ease;\r\n}\r\n\r\n.championship-actions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.championship-button {\r\n  border: none;\r\n  border-radius: 999px;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 8px 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.championship-button.primary {\r\n  background: linear-gradient(90deg, var(--accent-start), var(--accent-end));\r\n  color: white;\r\n}\r\n\r\n.championship-button.secondary {\r\n  background: rgba(148, 163, 184, 0.12);\r\n  color: #e2e8f0;\r\n}\r\n\r\n.championship-button:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n.championship-registration-table {\r\n  display: grid;\r\n  gap: 10px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 16px;\r\n  background: var(--surface-strong);\r\n  padding: 12px;\r\n}\r\n\r\n.championship-registration-table .table-row {\r\n  display: grid;\r\n  grid-template-columns: 1.6fr 1fr 1.5fr;\r\n  gap: 12px;\r\n  align-items: center;\r\n  padding: 10px 0;\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.12);\r\n}\r\n\r\n.championship-registration-table .table-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.championship-registration-table .table-header {\r\n  font-size: 0.78rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  color: var(--muted);\r\n}\r\n\r\n.championship-registration-table .table-cell {\r\n  color: var(--text);\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.championship-registration-table select {\r\n  width: 100%;\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 10px 12px;\r\n  background: var(--surface);\r\n  color: var(--text);\r\n  font: inherit;\r\n}\r\n\r\n.championship-registration-table select:disabled {\r\n  opacity: 0.75;\r\n  cursor: not-allowed;\r\n  background: rgba(148, 163, 184, 0.08);\r\n}\r\n\r\n.championship-registration-table option {\r\n  background: var(--surface);\r\n  color: var(--text);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
